import { capitalize } from 'lodash/fp';

export type ParsedInlineBoardLink = {
    url: string;
    boardId: string;
    title: string;
    permissionId?: string;
};

/**
 * Matches the URL of a Milanote board link, and groups the board ID, slug, and permission ID.
 */
export const createInlineBoardLinkRegex = (urlOrigin: string) => {
    const originRegex = urlOrigin
        // Match http or https optionally
        .replace(/https?:\/\//, '(?:https?:\\/\\/)')
        // Allow links to work in both staging and app environments but don't create a new group
        .replace(/(app|staging)/g, '(?:app|staging)')
        // Make '.' match exactly that character
        .replace(/\./g, '\\.');

    return new RegExp(`${originRegex}/([12][0-9a-zA-Z]{13})/?([^?\\s]*)(?:\\?p=)?([a-zA-Z0-9]{11})?`, 'g');
};

export const getInlineBoardLinkDetailsFromMatch = (match: RegExpMatchArray) => {
    const [url, boardId, slug, permissionId] = match;
    const title = slug ? capitalize(decodeURIComponent(slug.replace(/-/g, ' '))) : 'Milanote Board';

    return {
        url,
        boardId,
        title,
        permissionId: permissionId || undefined,
    };
};

export const parseInlineBoardLinkText = (text: string, urlOrigin?: string): ParsedInlineBoardLink | null => {
    if (!urlOrigin) return null;

    const regex = createInlineBoardLinkRegex(urlOrigin);
    const match = regex.exec(text.trim());

    if (!match) return null;

    return getInlineBoardLinkDetailsFromMatch(match);
};
